// extracted by mini-css-extract-plugin
export default {"dropZone":"FileUploadDialog_dropZone__T1rGK"};